import {
  DynamicLinkType,
  FlexibleBlockBrickBanner,
  FlexibleBlockProps,
  FlexibleBlockTemplateBanner,
  TailwindCommonPalette,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getBannerBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateBanner>[] => {
  const brickBanner: FlexibleBlockBrickBanner = {
    ...brickCommon,
    brickName: 'Banner',
    brickType: 'banner',
    title: 'Banner title',
    description: 'Banner description',
    bgImage: '/assets/img/blocks/banner/banner.png',
    dynamicLink: {
      type: DynamicLinkType.EXTERNAL,
      url: 'https://thefusebase.com',
    },
    buttonText: 'Button',
    theme: {
      text: {
        main: [TailwindCommonPalette.WHITE],
      },
    },
    className: ['pt-5', 'px-8', 'pb-72'],
  };

  return [
    {
      title: 'Banner',
      template: {
        type: 'banner',
        view: 'basic',
      },
      bricks: [{ ...brickBanner, index: 0 }],
      wrapper: { ...getWrapperProps('none') },
      className: [],
    },
  ];
};
